import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';
import Select from 'react-select';

import { ClientManufacturerProductStatus } from 'lib/enums/ClientManufacturerProductEnums';
import ProductListFilter from 'lib/enums/ProductListFilter';

const options = [
  { label: 'Active', value: ClientManufacturerProductStatus.ACTIVE },
  { label: 'Inactive', value: ClientManufacturerProductStatus.INACTIVE },
];

function CutDryActiveStatusFilter({ selectedValue, updateFilters }) {
  return (
    <Form.Group>
      <Form.Label>Cut+Dry Active Status</Form.Label>
      <Select
        isClearable
        options={options}
        value={options.find(opt => opt.value === selectedValue) || null}
        onChange={opt => updateFilters(ProductListFilter.CND_ACTIVE_STATUS, opt?.value)}
      />
    </Form.Group>
  );
}

CutDryActiveStatusFilter.propTypes = {
  selectedValue: PropTypes.string,
  updateFilters: PropTypes.func,
};

export default CutDryActiveStatusFilter;
